import { createSelector } from 'reselect';
import { TYPES } from './constants';
import { createLoadingSelector } from '../@loadings';
import { createSuccessSelector } from '../@success';
import { createErrorSelector, createErrorPayloadSelector } from '../@errors';
import { EventDataState } from './types';
import { ReduxState } from '../types';

// Event
export const selectEventData = (state: ReduxState): EventDataState => state.eventData;
export const selectEvent = createSelector(selectEventData, ({ event }) => event);
export const selectEventId = createSelector(selectEvent, (event) => event.id);

export const selectEventLoading = createLoadingSelector(TYPES.LOAD_EVENT.TYPE);
export const selectEventSuccess = createSuccessSelector(TYPES.LOAD_EVENT.TYPE);
export const selectEventError = createErrorSelector(TYPES.LOAD_EVENT.TYPE);

export const selectGetIdEventLoading = createLoadingSelector(TYPES.GET_ID_EVENT.TYPE);
export const selectGetIdEventSuccess = createSuccessSelector(TYPES.GET_ID_EVENT.TYPE);
export const selectGetIdEventError = createErrorSelector(TYPES.GET_ID_EVENT.TYPE);

export const selectSaveEventLoading = createLoadingSelector(TYPES.SAVE_EVENT.TYPE);
export const selectSaveEventSuccess = createSuccessSelector(TYPES.SAVE_EVENT.TYPE);
export const selectSaveEventError = createErrorSelector(TYPES.SAVE_EVENT.TYPE);
export const selectSaveEventErrors = createErrorPayloadSelector(TYPES.SAVE_EVENT.TYPE);

export const selectDeletingEvent = createLoadingSelector(TYPES.DELETE_EVENT.TYPE);
export const selectDeletingEventSuccess = createSuccessSelector(TYPES.DELETE_EVENT.TYPE);
export const selectDeletingEventErrors = createErrorPayloadSelector(TYPES.DELETE_EVENT.TYPE);

export const selectSetInviteEvent = createLoadingSelector(TYPES.SET_INVITE_EVENT.TYPE);
export const selectSetInviteEventSuccess = createSuccessSelector(TYPES.SET_INVITE_EVENT.TYPE);
export const selectSetInviteEventErrors = createErrorPayloadSelector(TYPES.SET_INVITE_EVENT.TYPE);

export const selectEventDeclineLinemen = createLoadingSelector(TYPES.EVENT_DECLINE_LINEMEN.TYPE);
export const selectEventDeclineLinemenSuccess = createSuccessSelector(TYPES.EVENT_DECLINE_LINEMEN.TYPE);
export const selectEventDeclineLinemenErrors = createErrorPayloadSelector(TYPES.EVENT_DECLINE_LINEMEN.TYPE);

export const selectUpdateEventStatusLoading = createLoadingSelector(TYPES.UPDATE_EVENT_STATUS.TYPE);
export const selectUpdateEventStatusSuccess = createSuccessSelector(TYPES.UPDATE_EVENT_STATUS.TYPE);
export const selectUpdateEventStatusError = createErrorSelector(TYPES.UPDATE_EVENT_STATUS.TYPE);
export const selectUpdateEventStatusErrors = createErrorPayloadSelector(TYPES.UPDATE_EVENT_STATUS.TYPE);
